<template>
  <div v-if="item.participantId" class="m-2 center-ssn-btn">
    <button @click="copyParticipantSsn" class="btn btn-default btn-sm">Copy SSN</button>
  </div>
</template>

<script>
import Vue from 'vue';
import VueClipboard from 'vue-clipboard2';    
Vue.use(VueClipboard);

export default {
    props: ["item"],
    computed: {
        ...amfx.map("participant","ssn,fullName")
    },
    methods: {
        copyParticipantSsn(){
            if(!this.ssn){
                toastService.error("Error retrieving participant SSN");
                return;
            }

            this.$copyText(this.ssn).then(() => {
                toastService.success(`Copied SSN for ${this.fullName} to clipboard`);
            }, (e) => {
                toastService.error("Error copying SSN to clipboard.")
            });
        },
    }
};
</script>

<style lang="scss" scoped>
.center-ssn-btn {
  text-align:center;
}
</style>


// WEBPACK FOOTER //
// src/action-items/types/CopyParticipantSsn.vue